module.exports = __webpack_public_path__ + "img/32.6bf5860b.png";